/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


window.onload = (event) => {
  
//footer menu vars + handler
  let rrag_dropdown =  document.getElementById("block-footer-0");
  let button_arr = document.getElementsByClassName("footer__title heading h6");
  let aria_toggle = button_arr[0];
  
  aria_toggle.setAttribute("aria-expanded", "true");
  rrag_dropdown.style.height = "auto";
  
  
//cutting services side menu functions
  if(main.classList.contains("cutting-main") == true | main.classList.contains("wholesales-main") == true ){
    console.log("cutting services script running");
    //cutting services vars
    let cuttingArr = document.getElementsByClassName("side-menu-custom");
    let active = document.getElementsByClassName("active-para");
    let activeArr = Array.from(active);
    let windowHeight = window.innerHeight;
    console.log(windowHeight/4);
    const sections = document.getElementById('services-page-info').getElementsByClassName('section');
    Array.from(sections);
   /* const accordHead = document.getElementsByClassName("accordion-head");
    const accordHeadArr = Array.from(accordHead);*/
    const main = document.getElementById("main");
    let cutFirstSec = document.getElementById("shopify-section-custom-html");
    let wholeFirstSec = document.getElementById("shopify-section-template--15490748940458__main");
    let sideMenu = document.getElementById("custom-sidebar").firstElementChild;
    let sideMenuContainer = document.getElementById("custom-sidebar");
    let scrollY = window.pageYOffset;
    
    let isScrolledIntoView = function (elem)
        {
            let elemTop = elem.getBoundingClientRect().top;

          return (elemTop < (windowHeight - (windowHeight/1.5)) && elemTop > 0);
        };
    
   let secArr = Array.from(document.getElementById("services-page-info").children);
 
           console.log(sideMenuContainer.getBoundingClientRect().top);
   
   Array.from(cuttingArr).forEach(function(link, i) {
    
        let id = link.id;
        let section = document.getElementsByClassName(id);
        let secCoord = section[0].getBoundingClientRect().top;
        let scrollPos = secCoord + scrollY - 210;
     
     if(window.innerWidth < 1000) {
     	scrollPos = secCoord + scrollY - 150;
     }
     
        link.addEventListener("click", function(){
         window.scrollTo({
              top: scrollPos,
              behavior: "smooth"        
              });
        });    	  
   });  
    
     
      if(main.classList.contains("cutting-main") == true){
      if(sideMenuContainer.getBoundingClientRect().top <= 174){
        if(window.innerWidth < 1000) {
          sideMenu.style.cssText = "position: fixed; left: 40px; top: 165px;";
        }else {
          sideMenu.style.cssText = "position: fixed; left: 50px; top: 230px;";
        };
      }else {
        sideMenu.style.cssText = "position: absolute; left: 50px;";

      }; 
    }else {

      if(sideMenuContainer.getBoundingClientRect().top <= 174){
        console.log(sideMenuContainer.getBoundingClientRect().top);
        if(window.innerWidth < 1000) {
          sideMenu.style.cssText = "position: fixed; left: 40px; top: 165px;";
        }else {
          sideMenu.style.cssText = "position: fixed; left: 50px; top: 230px;";
        };
      }else {
        sideMenu.style.cssText = "position: absolute; left: 50px;";

      }; 
    };
  //cutting services accordion
   /* accordHeadArr.forEach(function(curr){
      let arrow = curr.getElementsByTagName("span");	
      let body = curr.nextElementSibling;

      curr.parentElement.addEventListener("click", function(){

        if(curr.getAttribute("aria-expanded") == "false"){
          curr.setAttribute("aria-expanded", true);
          arrow[0].style.transform = 'rotate(90deg)';
          body.style.display = "block";
          setTimeout(() => {body.style.height = "100%"}, 50);
          setTimeout(() => {body.firstElementChild.style.opacity = "1"}, 250);

        }else {
          curr.setAttribute("aria-expanded", false);
          arrow[0].style.transform = 'rotate(0deg)';
          body.style.height = "0";
          setTimeout(() => {body.style.display = "none"}, 600);
          setTimeout(() => {body.firstElementChild.style.opacity = "0"}, 250);
        };
      });
    });*/


    //resize events
    window.addEventListener("resize", function(){
      let scrollY = window.pageYOffset;
             
      
      Array.from(cuttingArr).forEach(function(link, i) {
       console.log("run");
        let id = link.id;
        let section = document.getElementsByClassName(id);
        let secCoord = section[0].getBoundingClientRect().top;
 
        let scrollPos = secCoord + scrollY - 160;
        console.log(scrollPos);
        link.addEventListener("click", function(){
         window.scrollTo({
              top: scrollPos,
              behavior: "smooth"        
              });
          console.log(secCoord + " + " + scrollY + "- 160 =" + scrollPos);
        });    	  
      });
    });
    console.log(sections);
    
    
    //scroll events
    window.onscroll = function() { 
      if(main.classList.contains("cutting-main") == true){
        if(sideMenuContainer.getBoundingClientRect().top <= 174){
          if(window.innerWidth < 1000) {
            sideMenu.style.cssText = "position: fixed; left: 40px; top: 165px;";
          }else {
            sideMenu.style.cssText = "position: fixed; left: 50px; top: 230px;";
          };
        }else {
          sideMenu.style.cssText = "position: absolute; left: 50px;";

        }; 
      }else {

        if(sideMenuContainer.getBoundingClientRect().top <= 174){
          console.log(sideMenuContainer.getBoundingClientRect().top);
          if(window.innerWidth < 1000) {
            sideMenu.style.cssText = "position: fixed; left: 40px; top: 165px;";
          }else {
            sideMenu.style.cssText = "position: fixed; left: 50px; top: 230px;";
          };
        }else {
          sideMenu.style.cssText = "position: absolute; left: 50px;";

        }; 
      };
      
      if(document.querySelector('footer.footer').getBoundingClientRect().top < 500) {
      	sideMenu.style.opacity = "0";
      }else {
      	sideMenu.style.opacity = "1";
      };

      
      Array.from(sections).forEach(function(section, i) {

        if(isScrolledIntoView(section) == true) {
        	Array.from(activeArr).forEach(function(active){
              if(active.classList.contains("active-para-slide") == true) {
                  active.classList.remove("active-para-slide");   
              }else{
                  return
              };
          	});
          
        	activeArr[i].classList.add("active-para-slide");
        }else {
            return;       
        };
      
      });
    };
  };
  
//scroll to top button
  let sectionCollection = document.getElementById("scroll-to-top");
  
  if (sectionCollection) {
    let scrollButton = document.getElementById("scroll-to-top");
    let targetElement = document.getElementById("observer-box");
    console.log(targetElement);

   let options = {
     root: null,
     threshold: 0,
    };
    
    let callback = (entries, observer) => {
      entries.forEach(entry => {
          if(entry.boundingClientRect.top > 0 && entry.isIntersecting) {
            scrollButton.classList.remove("hide");
            console.log('below')
          }else if(entry.boundingClientRect.bottom > 0 && entry.isIntersecting) {
            scrollButton.classList.add("hide");
            console.log('above');
          }else if(entry.boundingClientRect.bottom > 0) {
            console.log('load-below-page');
            return
          }else if(entry.boundingClientRect.bottom < 0) {
            console.log('load-above-page');
            scrollButton.classList.remove("hide");
          };
      });
    };

    let observer = new IntersectionObserver(callback, options);
    observer.observe(targetElement);

    function scrollToTop() {
      console.log("scroll function running")
      setTimeout(function(){
          document.documentElement.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        }, 
      350);
      scrollButton.classList.add("hide");
    };
    
    scrollButton.addEventListener('click', scrollToTop);
  };
 
};

// Move the Smart Search & Filter app's mobile "Filter" button into the collection / search toolbar, on the far left
// (next to Sort by and View). The app re-renders its controls and the theme re-renders the toolbar, so this re-runs
// whenever the page changes.
(function () {
  function placeFilterButton() {
    var link = document.querySelector('.cloud-search-page-controls__filters-link');
    var toolbar = document.querySelector('.collection__toolbar');
    if (!link || !toolbar || toolbar.contains(link)) { return; }

    var item = toolbar.querySelector('.collection__toolbar-item--cloud-filter');
    if (!item) {
      item = document.createElement('div');
      item.className = 'collection__toolbar-item collection__toolbar-item--cloud-filter';
      toolbar.insertBefore(item, toolbar.firstElementChild);
    }
    item.appendChild(link);
  }

  // Only show the button while the app's sidebar is hidden (the app switches between the two itself)
  function syncFilterButton() {
    var sidebar = document.querySelector('.cloud-search-filters-sidebar');
    var sidebarVisible = !!(sidebar && sidebar.offsetWidth > 0 && sidebar.offsetHeight > 0);
    var filterButton = document.querySelector('.cloud-search-page-controls__filters-link');

    // html.cloud-filter-button-mode = the Filter button is showing instead of the sidebar (used by the search page CSS)
    document.documentElement.classList.toggle('cloud-filter-button-mode', !!filterButton && !sidebarVisible);

    var item = document.querySelector('.collection__toolbar-item--cloud-filter');
    if (!item) { return; }
    item.classList.toggle('collection__toolbar-item--sidebar-visible', sidebarVisible);
  }

  var queued = false;
  function queuePlace() {
    if (queued) { return; }
    queued = true;
    window.requestAnimationFrame(function () { queued = false; placeFilterButton(); syncFilterButton(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    placeFilterButton();
    syncFilterButton();
    window.addEventListener('resize', queuePlace);
    new MutationObserver(queuePlace).observe(document.body, { childList: true, subtree: true });
  });
})();
